import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { FooterMenu } from './FooterMenu/FooterMenu';
import { HeaderMenu } from './HeaderMenu/HeaderMenu';

export type NavigationProps = SliceComponentProps<Content.NavigationSlice>;

const Navigation = ({ slice }: NavigationProps): JSX.Element => {
  const { variation } = slice;
  return variation === 'default' ? (
    <HeaderMenu slice={slice} />
  ) : (
    <FooterMenu slice={slice} />
  );
};

export default Navigation;
